<template>
  <div class="teller-list">
    <div class="inn">
      <p class="bread-path">
        <span class="link-top" @click="toUranaiTv">占いTV</span>
        > <span class="link-teller">占い師名鑑</span>
      </p>
      <div class="tellers">
        <div v-for="(teller, i) in tellerLists" :key="i" class="tellers__box">
          <div class="tellers__inn">
            <img :src="teller.tellerList.thumbnail" :alt="teller.name" class="tellers__thumb">
            <div class="tellers__infos">
              <div class="tellers__name">{{ teller.name }}<span v-if="teller.kana">（{{ teller.kana }}）</span></div>
              <div class="tellers__method">占術：{{ teller.mainMethod }}<span v-if="teller.mainMethodKana">（{{ teller.mainMethodKana }}）</span></div>
              <div class="tellers__description">{{ teller.tellerList.description }}</div>
              <div class="tellers__free"><a :href="`/recommend/lp/${teller.id}/basic/input`">{{ teller.mainMethod }}で占う（無料）</a></div>
              <div class="tellers__profile"><a :href="`/teller/${teller.id}`">{{ teller.name }}紹介ページへ</a></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <lp-footer :menu-list="footerMenuList" />
  </div>
</template>

<script>
import { BASIC_DATA_BY_LPID, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import LpFooter from '@/utvStore/components/recommend/lp/blocks/LpFooter'

export default {
  name: 'TellerList',
  components: {
    LpFooter,
  },
  data() {
    return {
      // 表示順
      tellerListsOrder: [1, 4, 6, 5, 3, 2],
    }
  },
  computed: {
    // 表示順を元にデータ参照
    tellerLists() {
      let arr = []
      for (let id of this.tellerListsOrder) {
        arr.push(BASIC_DATA_BY_LPID[id].information.profile)
      }
      return arr
    },
    footerMenuList(){
      return [ ...DEFAULT_FOOTER_MENULIST, ]
    },
  },
  methods: {
    toUranaiTv(){
      location.href = this.$handoverParams('/')
    },
  }
}
</script>

<style scoped lang="scss">
$l_col_keycolor: var(--key-color);
.teller-list {
  color: #32373F;
  .inn {
    padding: 20px 20px 60px;
    margin: 0 auto;
  }
  .bread-path {
    margin: 0 -10px 20px 0;
    font-size: 13px;
    line-height: 21px;
    color: #656D78;
    .link-top {
      text-decoration-line: underline;
      cursor: pointer;
    }
    .link-teller {
      font-weight: 700;
    }
  }
  .tellers {
    &__box {
      margin: 0 auto 16px;
      padding: 1px;
      border-radius: 10px;
      background-image: linear-gradient(90deg, #FF7497, #CB8BFF);
      &:last-child {
        margin-bottom: 0;
      }
    }
    &__inn {
      background: #FFFFFF;
      border-radius: 10px;
      padding: 20px;
      display: flex;
      align-items: flex-start;
    }
    &__thumb {
      flex: 0 1 auto;
      width: 28%;
      max-width: 80px;
    }
    &__infos {
      flex: 1 1 auto;
      margin: 0 0 0 16px;
      font-size: 14px;
      line-height: 16px;
      text-align: justify;
    }
    &__name {
      font-weight: 700;
      font-size: 16px;
      line-height: 18px;
      margin: 0 0 8px;
    }
    &__method {
      font-weight: 700;
      line-height: 18px;
      margin: 0 0 12px;
    }
    &__description {
      line-height: 20px;
      margin: 0 0 16px;
    }
    &__free {
      font-weight: 700;
      margin: 0 0 12px;
    }
    &__profile {
      font-weight: 700;
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/utvStore/components/teller/TellerList.vue